import { Box, Flex, Image, Stack, Tag, Text, VStack } from "@chakra-ui/react";
import { useMemo } from "react";
import { t } from "i18next";
import { CraAttribute, CraAttributeType } from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../../../../coding/utils/attribute-utils";

interface Props {
  label: string;
  scoreImpact: number;
  attribute: CraAttribute;
  value: any;
  valueIsForecasted: boolean;
}
export const AttributeItem: React.FC<Props> = ({
  label,
  scoreImpact,
  attribute,
  value,
  valueIsForecasted,
}) => {
  const printedValue = useMemo(() => {
    if (!value) return value;

    if (attribute.type === CraAttributeType.Select) {
      return CraAttributeUtils.getOptionLabel(value);
    }

    return value;
  }, [attribute, value]);

  const image = useMemo(() => {
    if (
      value &&
      attribute.type === CraAttributeType.Select &&
      attribute.useImageSelection
    ) {
      return (
        <Image
          {...imageProps}
          title={CraAttributeUtils.getOptionLabel(value)}
          alt={CraAttributeUtils.getOptionLabel(value)}
          src={CraAttributeUtils.getImage(attribute, value)}
        />
      );
    } else if (
      attribute.type === CraAttributeType.Number ||
      (attribute.type === CraAttributeType.Select && !attribute.useImageSelection)
    ) {
      return (
        <Image
          {...imageProps}
          title={CraAttributeUtils.getLabel(attribute.name)}
          alt={CraAttributeUtils.getLabel(attribute.name)}
          src={CraAttributeUtils.getImage(attribute, value)}
        />
      );
    }

    return null;
  }, [attribute, value]);

  return (
    <Box>
      <Flex alignItems="center">
        <VStack mr={1} gap={0} width="76px" ml={-2} flexShrink={0}>
          {image}
        </VStack>

        <Stack gap={0}>
          <Text fontSize="xs" textTransform="uppercase" fontWeight="bold">
            {label}
          </Text>
          <Text fontSize="sm">{printedValue || "-"}</Text>
          <Text fontSize="xs">
            {`${t("map:attributes.impact")}: `}
            <Box as="span" fontWeight="semibold">
              {scoreImpact}%
            </Box>
          </Text>
          <Box>
            {valueIsForecasted && (
              <Tag.Root my={1} size="sm" colorPalette="primary">
                <Tag.Label>{t("map:attributes.forecastedValue")}</Tag.Label>
              </Tag.Root>
            )}
          </Box>
        </Stack>
      </Flex>
    </Box>
  );
};

const imageProps: any = {
  minWidth: "100%",
  width: "100%",
  mt: -3,
  mb: -1,
  loading: "lazy",
};
